module.exports = __webpack_public_path__ + "static/media/bpt_logo.d62f9b97.png";